import React, { useEffect } from "react";
import { navigateToAdmin } from "../../utils/navigation";

export default function Index() {
  useEffect(() => {
    localStorage.clear();
    navigateToAdmin();
  });
  return <div></div>;
}
